import React from "react";
import styled from "styled-components";
import * as yup from "yup";
import cl from "classnames";
import {Link} from "react-router-dom";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import axios from "axios";

const schema = yup.object({
    login: yup.string().required(),
    password: yup.string().required(),
    email: yup.string().required().email(),
});

export default function Register({fn: {register: onRegister}}) {
    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm({
        resolver: yupResolver(schema),
    });

    //
    function submit(data) {
        console.log('seubbubu')

        onRegister(data);
    }

    return (
        <StyledRegister className="main">
            <div className="container">
                <div className="auth">
                    <div className="auth_header">
                        <div className="auth_icon display-6 bi bi-person-plus text-center"></div>
                        <h1 className="mb-4 text-center">Регистрация</h1>
                    </div>
                    <div className="auth_form_wrapper row justify-content-center">
                        <div className="col-sm-8 col-md-7 col-lg-5">
                            <form
                                className="auth_form"
                                autoComplete="off"
                                noValidate
                                onSubmit={handleSubmit(submit)}
                            >
                                <div className="auth_form_group mb-3">
                                    <label className="form-label">Имя</label>
                                    <input
                                        type="text"
                                        className={cl("form-control", {
                                            "is-invalid": !!errors.login,
                                        })}
                                        {...register("login")}
                                    />
                                    {errors.login && (
                                        <div className="invalid-feedback">
                                            {errors.login.message}
                                        </div>
                                    )}
                                </div>
                                <div className="auth_form_group mb-3">
                                    <label className="form-label">Email</label>
                                    <input
                                        type="email"
                                        className={cl("form-control", {
                                            "is-invalid": !!errors.email,
                                        })}
                                        {...register("email")}
                                    />
                                    {errors.email && (
                                        <div className="invalid-feedback">
                                            {errors.email.message}
                                        </div>
                                    )}
                                </div>
                                <div className="auth_form_group">
                                    <label className="form-label">Пароль</label>
                                    <input
                                        type="password"
                                        className={cl("form-control", {
                                            "is-invalid": !!errors.password,
                                        })}
                                        {...register("password")}
                                    />
                                    {errors.password && (
                                        <div className="invalid-feedback">
                                            {errors.password.message}
                                        </div>
                                    )}
                                </div>
                                <div className="auth_form_group text-end my-4 small">
                                    <div className="text-muted">
                                        Есть аккаунт?{" "}
                                        <Link to="/auth/login" className="blue_link">
                                            Войти
                                        </Link>
                                    </div>
                                </div>
                                <div className="auth_form_group">
                                    <button
                                        className="auth_form_btn btn btn-primary w-100"
                                        type="submit"
                                    >
                                        Создать аккаунт
                                    </button>
                                </div>
                                {/* <div className="auth_form_group auth_form_bottom">
                  <div className="my-4 auth_form_bottom_stroke">
                    <div className="auth_form_bottom_text">
                      С помощью социальных сетей
                    </div>
                  </div>
                  <Link
                    to="#"
                    className="auth_form_git btn w-100 border btn-outline-secondary"
                  >
                    <span className="bi bi-github"></span>
                  </Link>
                </div> */}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </StyledRegister>
    );
}

const StyledRegister = styled.main`
  .auth_form {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 0.25rem;
    box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%);
    padding: 2.5rem;
  }

  .auth_form_bottom_text {
    text-align: center;
    font-size: 0.875em;
    color: #6c757d;
    position: relative;
    background: #fff;
    z-index: 2;
    padding: 0 16px;
    display: inline-block;
  }

  .auth_form_bottom_stroke:after {
    content: "";
    width: 100%;
    height: 1px;
    background: #dbdddf;
    left: 0;
    bottom: 10px;
    position: absolute;
  }

  .auth_form_bottom_stroke {
    position: relative;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
`;
